import React, {Component} from 'react'
import {
  pipe,
  prop,
  map,
  keys,
  __,
  path,
  filter,
  identity,
  pathOr,
} from 'ramda'
import { Spinner } from '@blueprintjs/core'
import Topbar from 'containers/project/topbar'
import Hint from 'containers/project/hint'

import 'less/errors-box.less'

const warnings = {
  moreCompletionsNeededThanAvailableSlots: "You're requesting more completes than you have defined moderator availability; your survey might not close on its own.",
}

const finalizingMessage = "The project is currently being finalized to ensure accuracy, process transcriptions, and finalize billing. You will be able to view your results as always but will be unable to edit the project. The finalizing process will take approximately 72 hours to complete after which the project will be closed."

export default class SubRouteContainer extends Component {

  componentDidMount () {
    const urlPath = path(['match', 'path'], this.props)
    const onDashboard = urlPath === '/projects/:projectId/dashboard'
    this.fetchProject(this.props, onDashboard)
  }

  componentWillReceiveProps (nextProps) {
    // Only refetch if the projectId in the URL actually changed
    const currentProjectId = this.props.match.params.projectId
    const nextProjectId = nextProps.match.params.projectId
    if (nextProjectId !== currentProjectId) {
      this.fetched = false
      this.fetchProject(nextProps)
    }
  }

  componentDidUpdate () {
    const urlPath = path(['match', 'path'], this.props)
    const pathHasProjectId = this.props.match.params.projectId
    const onEdit = urlPath === '/projects/:projectId/edit'
    const onReview = urlPath === '/projects/:projectId/review'
    const isInquiryOrInReview = this.props.currentProject &&
      (this.props.currentProject.projectStatusId === 1 || this.props.currentProject.projectId === 5)
    if (
      pathHasProjectId &&
      isInquiryOrInReview &&
      this.props.match.params.projectId === this.props.currentProject.id &&
      !(onEdit || onReview)
    ) {
      this.props.history.replace(`/projects/${this.props.match.params.projectId}/review`)
    }
  }

  fetched = false

  fetchProject = (props, refresh) => {
    const nextProjectId = props.match.params.projectId
    const shouldFetchNewProject = nextProjectId !== (props.currentProject.id || '').toString()
    if (
      !this.fetched &&
      ((nextProjectId && shouldFetchNewProject) || (nextProjectId && refresh))
    ) {
      this.fetched = true;
      this.props.fetchAllInformationForProject(nextProjectId);
    }
  }

  render () {
    const urlPath = path(['match', 'path'], this.props)
    const onDashboard = urlPath === '/projects/:projectId/dashboard'
    const onRecruiter = urlPath === '/projects/:projectId/recruiters/:surveyId'
    //const onQuestionList = urlPath === '/projects/:projectId/recruiters/:surveyId/screeners'
    const warningsToShow = pipe(
      filter(identity),
      keys,
      map(prop(__, warnings)
    ))(this.props.warnings)
    const projectId = this.props.match.params.projectId
    const loadingNextProject = (projectId && projectId !== (this.props.currentProject.id || '').toString())
    const isFinalizing = this.props.currentProject.projectStatusId === 7
    const isComplete = this.props.currentProject.projectStatusId === 4
    return (
      <div>
        <Topbar
          {...this.props}
          urlPath={urlPath}
          openModal={this.props.openModal}
          currentProject={this.props.currentProject}
          launch={this.props.launch}
          toggleCloseWarning={this.props.toggleCloseWarning}
          loadingNextProject={loadingNextProject}
          title={"Projects"}
        />
        {
            loadingNextProject ?
              <Spinner intent="primary" /> :
            <div>
              {onDashboard && <Hint
                showAvailabilityWarning ={(pathOr({}, ['currentProject', 'showWarningBanner']))(this.props) && (pathOr('moderator', ['currentProject', 'schedulingType']))(this.props) !== 'project'}
              />}
              {/* {(onQuestionList || onRecruiter) && */}
              {/* {onDashboard &&
                this.props.displayAllErrors &&
                Boolean(this.props.surveyErrors.length) &&
                !isFinalizing &&
                !isComplete &&
                <div className="errors-box">
                  Please resolve any issues with the following survey(s) before launching:
                  <div className="line" />
                  {this.props.surveyErrors.map(({id, namePrivate, validationErrors}) =>
                    <div className="survey-errors" key={id}>
                      <span className="survey-name">{namePrivate}:</span>
                      <ul className="validation-errors">
                        {validationErrors.map((error, i) => <li key={i}>{error}</li>)}
                      </ul>
                    </div>
                  )}
                </div>
              } */}
              {onDashboard && Boolean(warningsToShow.length) && !isFinalizing && !isComplete &&
                <div className="warnings-box">
                  <span className="warning-header">Warning</span>
                  {warningsToShow.map((warning, i) => <div key={i}>{warning}</div>)}
                </div>
              }
              {onDashboard && isFinalizing &&
                <div className="warnings-box">
                  <span className="finalizing-header">Finalizing Project</span>
                  <hr></hr>
                  <div>{finalizingMessage}</div>
                </div>
              }
              <this.props.component
                {...this.props}
                {...this.props.timeSlotInfo}
                currentProject={this.props.currentProject}
                updateState={this.props.updateState}
                forAdmin
              />
            </div>
        }
      </div>
    )
  }
}
